import { createSlice } from '@reduxjs/toolkit';

interface DrawerState {
    refreshExpired: boolean;
}

const initialState: DrawerState = {
    refreshExpired: true,
};

const refreshExpiredSlice = createSlice({
    name: 'refreshExpired',
    initialState,
    reducers: {
        refreshExpiredFunc: (state) => {
            state.refreshExpired = !state.refreshExpired;
        },
    },
});

export const { refreshExpiredFunc } = refreshExpiredSlice.actions;

export default refreshExpiredSlice.reducer;
